// Resolve the API base URL at runtime.
//
// On the Emergent platform, the ingress proxies every `/api/*` request from
// the same host the page is served on to the backend pod. That means a
// same-origin call always reaches the correct backend whether the page is
// loaded from the preview (`*.preview.emergentagent.com`) or the production
// (`*.emergent.host`) deploy domain.
//
// We previously read `process.env.REACT_APP_BACKEND_URL` directly. That URL
// is baked in at build time, so a production build that was compiled with
// the preview backend URL ends up making cross-origin requests to the
// preview backend — and the Emergent ingress answers the OPTIONS preflight
// with `Access-Control-Allow-Origin: *`, which the browser rejects when the
// request uses `credentials: include`. The login form then surfaces the
// generic "Something went wrong" fallback.
//
// Preferring `window.location.origin` in the browser fixes this defensively
// on both environments. We still fall back to the env var for non-browser
// contexts (tests, SSR) so behaviour outside the browser is unchanged.
export const API_BASE =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || '');
